import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 2.666c.369 0 .667.298.667.667v4h4a.667.667 0 1 1 0 1.333h-4v4a.667.667 0 1 1-1.333 0v-4h-4a.667.667 0 0 1 0-1.333h4v-4c0-.369.298-.667.666-.667", fill: "#C5C5CA" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
